module.exports = __webpack_public_path__ + "img/92196.3241937e.svg";